import React from 'react'
import { useContext, useState, useEffect } from 'react';
import DataContext from '../Context/DataContext';
import { useNavigate } from 'react-router-dom';
import BasicImageList from './BasicImageList';
import ProgressIndicator from '../Indicator/ProgressIndicator';

const AdultNonMilking = () => {
    const { isLoading, items } = useContext(DataContext);
    const [imagelist, setImageList] = useState([]);
    // console.log(isLoading);
    let navigate = useNavigate();
    useEffect(()=>{
      if (!isLoading){
        setImageList(
            items.map(item =>{         
              const infolist = [
                `Days since last delivery: ${item.dayssincelastdelivery}`,
                `Days since IV: ${item.dayssinceiv===999?'NA': item.dayssinceiv}`,
                `Days since deworming: ${item.dayssincedeworming ===999?'NA': item.dayssincedeworming}`
              ];
                return (
                    [
                        item.cowid,
                        item.image1,
                        item.tag,
                        item.status,
                        item.isMilking,
                        item.isVerified,
                        item.status,
                        infolist
                    ]
                );        
            }).filter(value => (value[3] === 'Adult Female' & value[4] === 0))
        );
      }
    },[isLoading]);
//    console.log(items);
        
  return (
    <>
     {isLoading && <ProgressIndicator /> }
{    !isLoading && <BasicImageList title={"Adult Non Milking"} imglist={imagelist}  />}
    </>
  )
}

export default AdultNonMilking